import styled from 'styled-components';

export const LabeledValueWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 13px;

    &#country {
        .value {
            text-transform: capitalize;
        }
    }
`;

export const LValue = styled.span`
    color: #000000;
    margin-top: 20px;
`;

export const LLabel = styled.span`
    color: #777777;
`;
